import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function ({ url, id, title, subtitle, cover, author, alt, queue, bar, fullscreen, handleSwipe }) {
  const [progress, setProgress] = useState("carousel-bar-filled");

  useEffect(() => {
    setProgress("");
    setProgress("carousel-bar-filled");
  }, [queue]);

  const [seconds, setSeconds] = useState(1);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds + 1);
    }, 1000);

    return () => clearInterval(intervalId); // Limpiar el intervalo al desmontar el componente
  }, []); //

  return (
    <Link onClick={() => {
      window.scrollTo(0, 0)
    }} to={`/article/${id}`} className="carousel-item"  onTouchStart={handleSwipe} onMouseDown={handleSwipe}>
      {bar ? (
        <div className="carousel-bar">
          {" "}
          <span className="carousel-bar-filled"></span>{" "}
        </div>
      ) : (
        <></>
      )}

{title || subtitle ? (
        <div className="carousel-text-cont">
          <p className="carousel-item-category">Nota de tapa</p>
          {author ? <p className="carousel-item-author">Por {author}</p> : <></>}
          {title ? <p className="carousel-item-title">{title}</p> : <></>}
          {subtitle ? (
            <p className="carousel-item-description">{subtitle}</p>
          ) : (
            <></>
          )}
        </div>
      ) : (
        <></>
      )}

        <img className={`carousel-img ${fullscreen ? "carousel-img-fullscreen" : ""}`} src={cover} alt={alt} />
  
     

      {/* <p className='carousel-seconds'> {seconds} </p> */}
    </Link>
  );
}
